import { render, staticRenderFns } from "./form.vue?vue&type=template&id=41d3dbf2"
import script from "./form.vue?vue&type=script&setup=true&lang=js"
export * from "./form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports